export default __webpack_public_path__ + "static/media/icon-arrow-down.1c8afbd3.svg";